/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SubjectInputs */

const cs_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předmět`)
};

const en_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Field_SubjectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_subject = /** @type {((inputs?: Field_SubjectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SubjectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_subject(inputs)
	return cs_field_subject(inputs)
});